import { render, staticRenderFns } from "./DeliveryProvider.vue?vue&type=template&id=1a52574e&scoped=true&"
import script from "./DeliveryProvider.vue?vue&type=script&lang=js&"
export * from "./DeliveryProvider.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryProvider.vue?vue&type=style&index=0&lang=css&"
import style1 from "./DeliveryProvider.vue?vue&type=style&index=1&id=1a52574e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a52574e",
  null
  
)

export default component.exports